import {GetPortabilityCardUrl} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetPortabilityCardUrl} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetPortabilityCardUrl = (): GetPortabilityCardUrl =>
	new RemoteGetPortabilityCardUrl(
		makeBFFApiUrl(ExternalLinkPoint.portabilityCard),
		makeAuthorizeHttpClientDecorator(),
	);
